<template>
  <button class="UIDropdownToggle">
    <slot />
    <UIIcon
      :class="[
        'UIDropdownToggle__icon',
        {
          'UIDropdownToggle__icon--is-opened': isOpen,
        },
      ]"
      name="chevronDown"
    />
  </button>
</template>

<script lang="ts" setup>
import UIIcon from '../icons/UIIcon.vue'

defineProps<{
  isOpen?: boolean
}>()
</script>

<style scoped lang="scss">
.UIDropdownToggle {
  display: flex;
  align-items: center;
  position: relative;
  gap: 0.125rem;
  padding-right: 0.5rem;

  .UIDropdownToggle__icon {
    @include trans(0.1s);

    &--is-opened {
      transform: rotate(180deg);
    }
  }
}
</style>
